import React, { useState } from 'react';
import { Button, Alert } from 'reactstrap';
import axios from 'axios';
import { URI } from '../../providers/apolloClient';

const SendResetPasswordEmail = ({ email }) => {
  const [success, setSucess] = useState(false);
  const [error, setError] = useState(false);

  const sendResetPasswordEmail = async () => {
    // eslint-disable-next-line no-alert
    const confirm = window.confirm(`Are you sure you want to send a reset password email to ${email}?`);

    if (confirm) {
      try {
        const response = await axios.post(`${URI}/auth/sendResetPasswordEmail`, { email });
        const { data: { success: responseSucess } } = response;
        if (responseSucess) {
          setSucess(true);
        } else {
          setError(true);
        }
      } catch (err) {
        setError(true);
      }
    }
  };

  if (!email) {
    return null;
  }

  return (
    <div>
      <Button
        type="submit"
        color="primary"
        onClick={sendResetPasswordEmail}
      >
        Send reset password email
      </Button>
      <Alert
        isOpen={success}
        toggle={() => setSucess(false)}
      >
        Reset password email sent!
      </Alert>
      <Alert
        color="danger"
        isOpen={error}
        toggle={() => setError(false)}
      >
        Reset password email failure, please retry
      </Alert>
    </div>
  );
};

export default SendResetPasswordEmail;



// WEBPACK FOOTER //
// ./src/components/user-info/send-reset-password-email.js